import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const tableVariants = tv({
  slots: {
    table: "w-full border-separate border-spacing-0 caption-bottom text-sm",
    container: "relative w-full h-full overflow-auto"
  }
}), tableWrapperScrollAreaVariants = tv({
  slots: {
    scrollArea: "overflow-hidden",
    head: "overflow-hidden",
    body: `
      grow w-(--eci-saas-ui-table-wrapper-scroll-area-body-width) h-(--eci-saas-ui-table-wrapper-scroll-area-body-height)
      overflow-y-hidden overflow-x-hidden
    `,
    headTable: "",
    bodyTable: "",
    noScrollTable: "",
    footer: "p-2 bg-muted/50 font-medium",
    empty: "h-full sticky top-0 start-0 content-center"
  },
  variants: {
    isHeightFull: {
      true: { scrollArea: "flex flex-col h-full", head: "shrink-0", footer: "shrink-0" },
      false: ""
    },
    // 高度自适应时使用
    isXScrollable: {
      true: { body: "overflow-x-auto" },
      false: {}
    },
    isYScrollable: {
      true: { body: "overflow-y-auto" },
      false: {}
    },
    footerTopBorder: {
      true: { footer: "m-[-1px] border-t border-r-(--gray-tag-2)" },
      false: {}
    }
  },
  compoundSlots: [
    { isXScrollable: !0, slots: ["headTable", "bodyTable"], class: "min-w-full w-max" }
  ],
  defaultVariants: {
    isHeightFull: !1,
    isXScrollable: !1,
    isYScrollable: !1,
    footerTopBorder: !1
  }
}), tableWrapperScrollRingVariants = tv({
  variants: {
    isStart: {
      false: `
        [&_[data-sticky-start]]:after:content-['']
        [&_[data-sticky-start]]:after:absolute
        [&_[data-sticky-start]]:after:z-10
        [&_[data-sticky-start]]:after:top-0
        [&_[data-sticky-start]]:after:end-[-15px]
        [&_[data-sticky-start]]:after:block
        [&_[data-sticky-start]]:after:h-full
        [&_[data-sticky-start]]:after:w-[15px]
        [&_[data-sticky-start]]:after:bg-linear-to-r
        rtl:[&_[data-sticky-start]]:after:bg-linear-to-l
        [&_[data-sticky-start]]:after:from-(--gray-tag-2)
        [&_[data-sticky-start]]:after:to-transparent
        [&_[data-sticky-start]]:after:pointer-events-none
        [&_[data-sticky-start]]:transition-all
      `,
      true: void 0
    },
    isEnd: {
      false: `
        [&_[data-sticky-end]]:after:content-['']
        [&_[data-sticky-end]]:after:absolute
        [&_[data-sticky-end]]:after:z-10
        [&_[data-sticky-end]]:after:top-0
        [&_[data-sticky-end]]:after:start-[-15px]
        [&_[data-sticky-end]]:after:block
        [&_[data-sticky-end]]:after:h-full
        [&_[data-sticky-end]]:after:w-[15px]
        [&_[data-sticky-end]]:after:bg-linear-to-l
        rtl:[&_[data-sticky-end]]:after:bg-linear-to-r
        [&_[data-sticky-end]]:after:from-(--gray-tag-2)
        [&_[data-sticky-end]]:after:to-transparent
        [&_[data-sticky-end]]:after:pointer-events-none
        [&_[data-sticky-end]]:transition-all
      `,
      true: void 0
    }
  },
  defaultVariants: {
    isStart: !0,
    isEnd: !1
  }
}), tableStickyCellVariants = tv({
  base: "",
  variants: {
    isSticky: {
      false: "",
      true: "sticky z-5 start-(--eci-saas-ui-table-wrapper-sticky-start,0) end-(--eci-saas-ui-table-wrapper-sticky-end,0) bg-(--white)"
    }
  },
  defaultVariants: {
    isSticky: !1
  }
});
export {
  tableStickyCellVariants,
  tableVariants,
  tableWrapperScrollAreaVariants,
  tableWrapperScrollRingVariants
};
//# sourceMappingURL=index.js.map
